import { AppError } from '../errors/app-error';

/**
 * Thrown when the API responds with a "profile not ready" envelope on
 * `GET /users/me`. The legacy app retries this up to 5 times — see
 * `AuthService` in growzz-web-app-legacy/app/components/login/auth.service.js.
 */
export class ProfileNotReadyError extends AppError {
  constructor(cause?: unknown) {
    super('not_found', 'Profile not ready yet', { status: 404, cause });
    this.name = 'ProfileNotReadyError';
  }
}
